import Class from './class'
import EventGenerator from './eventGenerator'

export default Class.extend('Socket', EventGenerator, {
  construct: function () {
    this.__name = ''
    this.__socket = null
    this.__queue = []
    this.__timer = null
    this.__endpoint = null
    this.__requestId = Number(new Date())
    this.__requests = []
  },

  connect: function (name, endpoint) {
    this.close()
    this.__name = name
    this.__socket = new WebSocket(endpoint)
    this.__socket.onopen = this.__onOpen.bind(this)
    this.__socket.onclose = this.__onClose.bind(this)
    this.__socket.onerror = this.__onError.bind(this)
    this.__socket.onmessage = this.__onMessage.bind(this)
    this.__endpoint = endpoint
  },

  request: function (msg) {
    return new Promise(function (resolve, reject) {
      this.__requests[this.__requestId] = { resolve: resolve, reject: reject }
      msg.messageId = this.__requestId++
      this.send(msg)
    }.bind(this))
  },

  timedRequest: function (msg) {
    return new Promise(function (resolve, reject) {
      this.__requests[this.__requestId] = { resolve: resolve, reject: reject, timed: true }
      msg.messageId = this.__requestId++
      this.send(msg, true)
    }.bind(this))
  },

  close: function () {
    if (this.__timer) {
      window.clearInterval(this.__timer)
      this.__timer = null
    }
    if (this.__socket) {
      this.__socket.onopen = null
      this.__socket.onclose = null
      this.__socket.onerror = null
      this.__socket.onmessage = null
      this.__socket.close()
      this.__socket = null
    }
    for (var i = 0; i < this.__requests.length; i++) {
      this.__requests[i].reject()
    }
    this.__requests = {}
    this.__queue = []
    this.__endpoint = null
  },

  send: function (data) {
    /*
    if (process.env.NODE_ENV !== 'production' && !timed) {
      // eslint-disable-next-line no-console
      console.log('[' + this.__name + '] sent:', data)
    }
    */
    this.__queueMsg(data)
  },

  endpoint: function () {
    return this.__endpoint
  },

  connected: function () {
    return this.__socket && this.__socket.readyState === WebSocket.OPEN
  },

  __queueMsg: function (msg) {
    if ((this.__queue.length === 0) && (this.__socket.bufferedAmount === 0)) {
      if (typeof msg === 'object') {
        if (msg.messageId && this.__requests[msg.messageId] && this.__requests[msg.messageId].timed) this.__requests[msg.messageId].sendTS = Number(new Date())
        msg = JSON.stringify(msg)
      }
      this.__socket.send(msg)
    }
    else {
      this.__queue.push(msg)
      if (!this.__timer) {
        this.__timer = window.setInterval(function () {
          while ((this.__queue.length > 0) && (this.__socket.bufferedAmount === 0)) {
            var msg = this.__queue.shift()
            if (typeof msg === 'object') {
              if (msg.messageId && this.__requests[msg.messageId] && this.__requests[msg.messageId].timed) this.__requests[msg.messageId].sendTS = Number(new Date())
              msg = JSON.stringify(msg)
            }
            this.__socket.send(msg)
            if (this.__queue.length === 0) {
              window.clearInterval(this.__timer)
              this.__timer = null
            }
            break
          }
        }.bind(this), 100)
      }
    }
  },

  __onOpen: function () {
    this.fire('connected')
  },

  __onClose: function () {
    this.close()
    this.fire('closed')
  },

  __onError: function (evt) {
    // eslint-disable-next-line no-console
    console.log('received error on socket', evt)
  },

  __computeClockDrift: function (t0, t1, t2, t3) {
    return Math.round(((t1 - t0) + (t2 - t3)) / 2)
  },

  __onMessage: function (evt) {
    var msg = JSON.parse(evt.data)
    if (msg.messageId && this.__requests[msg.messageId]) {
      var promise = this.__requests[msg.messageId]
      delete this.__requests[msg.messageId]
      if (promise.timed && msg.statTimeRequest && msg.statTimeResponse) {
        var drift = this.__computeClockDrift(promise.sendTS, msg.statTimeRequest, msg.statTimeResponse, Number(new Date()))
        delete msg.statTimeRequest
        delete msg.statTimeResponse
        delete msg.messageId
        promise.resolve({ drift: drift, rep: msg })
      }
      else {
        delete msg.statTimeRequest
        delete msg.statTimeResponse
        delete msg.messageId
        /*
        if ((process.env.NODE_ENV !== 'production') && (msg.MTI !== 3000 && msg.MTI !== 3200 && msg.MTI !== 3500)) {
          // eslint-disable-next-line no-console
          console.log('[' + this.__name + '] recv:', msg)
        }
        */
        promise.resolve(msg)
      }
    }
    else {
      /*
      if ((process.env.NODE_ENV !== 'production') && (msg.MTI !== 3000 && msg.MTI !== 3200 && msg.MTI !== 3500)) {
        // eslint-disable-next-line no-console
        console.log('[' + this.__name + '] recv:', msg)
      }
      */
      this.fire('message', msg)
    }
  }
})
